export default function Loader() {
  return (
    <div className='tw-w-full tw-h-2/3 tw-flex tw-items-center tw-justify-center'>
      <div className='eds-spinner eds-spinner--medium' />
      <h2 className='eds-type--display-5 tw-ml-5'>Loading</h2>
    </div>
  );
}
